'use strict';

/**
 * Quantity + add to cart control (snippets/buy-control.liquid, design B5) on the product page.
 *
 * - The main control's input (name="quantity", inside the product form) is the single source of truth;
 *   the mobile sticky bar mirrors it and its button clicks the main submit button.
 * - Button label: «Legg i kurv · 698 kr» when the quantity is above 1 or engravings are chosen
 *   (the sticky bar always shows the amount, since it has no separate price). For a signed-in member the total
 *   uses the member price ("mp" in the block data, set only for members).
 * - Status tab under the main control: stock and expected ready date for the chosen quantity, ported rule for
 *   rule from snippets/line-delivery.liquid so the product page and the cart say the same. data-state «ready»
 *   (all of it in stock) or «wait» colours the tab's left edge.
 * - Policy «deny» with tracked stock: + stops at the stock and the line says «Bare N igjen».
 * - Variant changes arrive as `pippei:variant-change` from <product-form>; after a successful add the cart
 *   script dispatches `pippei:added` on the form and the quantity goes back to 1.
 */
(function () {
  var form = document.querySelector('form[data-product-form]');
  var main = form && form.querySelector('[data-buy-control][data-mode="main"]');
  if (!main) return;

  var controls = Array.prototype.slice.call(document.querySelectorAll('[data-buy-control]'));
  var mainInput = main.querySelector('[data-buy-input]');
  var mainBtn = main.querySelector('#add-to-cart-btn');
  var help = form.querySelector('[data-buy-help]');
  var bar = document.getElementById('sticky-atc-bar');
  var stickyHelp = bar && bar.querySelector('[data-buy-help-short]');
  var stickyControl = bar && bar.querySelector('[data-buy-control]');
  var scope = form.closest('product-form') || document;

  var data = { restock: null, variants: {}, strings: {} };
  try { data = JSON.parse(document.querySelector('[data-buy-data]').textContent); } catch (e) { /* no helper line */ }
  var variants = [];
  try { variants = JSON.parse(document.getElementById('variant-data').textContent); } catch (e) { variants = []; }

  var idInput = form.querySelector('input[name="id"]');
  var current = variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || variants[0] || null;

  /* Without a quantity chip in the form, the sticky bar has none either. */
  if (!mainInput) controls.forEach(function (c) { var w = c.querySelector('[data-buy-qty-wrap]'); if (w) w.remove(); });

  function money(cents) { return (typeof formatMoney === 'function') ? formatMoney(cents) : (cents / 100) + ' kr'; }
  function info() { return current ? data.variants[String(current.id)] || null : null; }

  function maxQty() {
    var i = info();
    if (i && i.deny && i.inv !== null) return Math.max(1, i.inv);
    if (i && i.cap) return i.cap;   // long-term sold out: stock plus confirmed deliveries (snippets/qty-cap.liquid)
    return 9999;
  }

  /* Long-term sold out with nothing in stock or confirmed on the way: cap 0, cannot be ordered whatever the policy. */
  function blocked() { var i = info(); return !!(i && i.cap === 0); }
  function orderable() { return !!(current && current.available) && !blocked(); }

  function qty() { return mainInput ? Math.max(1, parseInt(mainInput.value, 10) || 1) : 1; }

  function engravingTotal() {
    var sum = 0;
    scope.querySelectorAll('[data-pippei-gravering-variant]:checked').forEach(function (cb) {
      sum += parseInt(cb.getAttribute('data-price'), 10) || 0;
    });
    return sum;
  }

  /* ---------- helper line (same rules as snippets/line-delivery.liquid) ---------- */

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function keyOf(d) { return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
  function fmt(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function parseDay(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  }
  function fill(tpl, map) {
    return Object.keys(map).reduce(function (s, k) { return s.split('__' + k + '__').join(map[k]); }, tpl || '');
  }

  /* Short status for the sticky bar, set by helperHtml(): «På lager», «Bare 3 igjen», «Klar 12.10»
     (the date when the whole quantity is ready) or «Dato ikke fastsatt». */
  var shortText = '';
  function shortDate(dmy) { return String(dmy).slice(0, 5); }

  function helperHtml(q) {
    var i = info(), s = data.strings || {};
    shortText = '';
    if (!orderable() || !i || i.inv === null) return '';
    var avail = Math.min(Math.max(i.inv, 0), q);
    var waiting = q - avail;
    if (i.deny) {
      if (i.inv > 0 && i.inv <= 5) { shortText = fill(s.only_left, { COUNT: i.inv }); return shortText; }
      shortText = i.inv > 0 ? s.in_stock : '';
      return shortText;
    }
    if (waiting <= 0) { shortText = s.in_stock || ''; return shortText; }

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var todayKey = keyOf(today);
    var back = parseDay(data.restock);
    var supplier = null;
    if (i.lead !== null) { supplier = new Date(today); supplier.setDate(supplier.getDate() + i.lead); }
    var selected = null;
    if (back && keyOf(back) >= todayKey) selected = back;
    else if (supplier && keyOf(supplier) >= todayKey) selected = supplier;

    var parts = [], fordelt = 0, last = null;
    if (i.tl && i.tl.length) {
      var base = i.inv, invPos = Math.max(base, 0), cum = base, freeSofar = 0;
      for (var n = 0; n < i.tl.length; n++) {
        var lev = i.tl[n], day = parseDay(lev.dato);
        if (!day || keyOf(day) < todayKey) continue;
        cum += parseInt(lev.inn, 10) || 0;
        var take = Math.max(cum, 0) - invPos - freeSofar;
        take = Math.min(take, waiting - fordelt);
        if (take > 0) {
          parts.push(take + ' stk ' + fmt(day));
          last = day;
          freeSofar += take;
          fordelt += take;
        }
        if (fordelt >= waiting) break;
      }
      var rest = waiting - fordelt;
      if (rest > 0) {
        var restDay = (supplier && keyOf(supplier) >= todayKey) ? supplier : null;
        if (restDay && last && last > restDay) restDay = last;
        parts.push(rest + ' stk ' + (restDay ? fmt(restDay) : (s.not_set || 'dato ikke fastsatt')));
      }
    }

    var map = { AVAILABLE: avail, QUANTITY: q, WAITING: waiting };
    var unknownDate = parts.some(function (p) { return !/\d{2}\.\d{2}\.\d{4}$/.test(p); });
    if (parts.length > 1) {
      map.DATES = parts.join(', ');
      shortText = unknownDate ? s.short_unknown : fill(s.short_ready, { DATE: shortDate(parts[parts.length - 1].split(' stk ').pop()) });
      return fill(avail > 0 ? s.split_partial_html : s.split_all_html, map);
    }
    if (parts.length === 1 || selected) {
      map.DATE = parts.length === 1 ? parts[0].split(' stk ').pop() : fmt(selected);
      shortText = unknownDate ? s.short_unknown : fill(s.short_ready, { DATE: shortDate(map.DATE) });
      return fill(avail > 0 ? s.single_partial_html : s.single_all_html, map);
    }
    shortText = s.short_unknown || '';
    return fill(avail > 0 ? s.unknown_partial : s.unknown_all, map);
  }

  /* ---------- render ---------- */

  function render() {
    var q = qty();
    var max = maxQty();
    if (q > max) { q = max; if (mainInput) mainInput.value = q; }
    var available = orderable();
    var lt = !!(info() && info().lt);
    form.querySelectorAll('[data-buy-lso]').forEach(function (p) {
      p.hidden = !lt || (p.getAttribute('data-buy-lso') === 'open') !== available;
    });
    var extras = engravingTotal();
    var i = info();
    /* A member price must be a positive amount below the price; anything else falls back to the price. */
    var unit = current ? ((i && i.mp > 0 && i.mp < current.price) ? i.mp : current.price) : 0;
    var total = unit * q + extras;

    controls.forEach(function (c) {
      var sticky = c.getAttribute('data-mode') === 'sticky';
      c.classList.toggle('is-sold-out', !available);
      var input = c.querySelector('[data-buy-input]');
      if (input && input !== document.activeElement) input.value = q;
      var minus = c.querySelector('[data-buy-step="-1"]');
      var plus = c.querySelector('[data-buy-step="1"]');
      if (minus) minus.disabled = !available || q <= 1;
      if (plus) plus.disabled = !available || q >= max;
      if (input) input.disabled = !available;
      var btn = c.querySelector('.pp-buy__add');
      if (btn) btn.disabled = !available;
      var label = c.querySelector('[data-atc-label]');
      if (label && btn) label.textContent = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold-out');
      var totalEl = c.querySelector('[data-atc-total]');
      if (totalEl) {
        var show = available && (sticky || q > 1 || extras > 0);
        totalEl.hidden = !show;
        totalEl.textContent = show ? money(total) : '';
      }
    });

    if (help) {
      var html = helperHtml(q);
      var i2 = info();
      var waitingNow = i2 && i2.inv !== null ? q - Math.min(Math.max(i2.inv, 0), q) : 0;
      help.innerHTML = html;
      help.hidden = !html;
      var state = (i2 && (i2.deny || waitingNow <= 0)) ? 'ready' : 'wait';
      help.setAttribute('data-state', state);
      main.classList.toggle('has-status', !!html);
      if (stickyHelp && stickyControl) {
        stickyHelp.textContent = html ? shortText : '';
        stickyHelp.hidden = !(html && shortText);
        stickyHelp.setAttribute('data-state', state);
        stickyControl.classList.toggle('has-status', !stickyHelp.hidden);
      }
    }
  }

  function setQty(n) {
    if (!mainInput) return;
    mainInput.value = Math.min(Math.max(1, n), maxQty());
    render();
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-buy-step]');
    if (step && step.closest('[data-buy-control]')) {
      e.preventDefault();
      setQty(qty() + parseInt(step.getAttribute('data-buy-step'), 10));
      return;
    }
    var proxy = e.target.closest && e.target.closest('[data-atc-proxy]');
    if (proxy && mainBtn && !mainBtn.disabled) {
      e.preventDefault();
      // The form's own button may be taken out of the page while the bar is detached: submit with it as submitter.
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    }
  });

  controls.forEach(function (c) {
    var input = c.querySelector('[data-buy-input]');
    if (!input) return;
    input.addEventListener('change', function () { setQty(parseInt(input.value, 10) || 1); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input !== mainInput) { e.preventDefault(); setQty(parseInt(input.value, 10) || 1); }
    });
  });

  scope.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-pippei-gravering-variant]')) render();
  });

  document.addEventListener('pippei:variant-change', function (e) {
    if (e.detail && e.detail.variant) { current = e.detail.variant; render(); }
  });

  form.addEventListener('pippei:added', function () { setQty(1); });

  /* «Til toppen» on the sticky bar: back to the images and the buy button. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-to-top]')) return;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
  });

  /* Sticky bar as a «reverse sticky» (Knut 2026-10-03), mobile only (the bar is hidden on desktop):
     - Scrolling down, when the bottom of the screen (the bar's slot) reaches the buy button, the button «detaches»:
       it stays pinned at the bottom (the bar takes over in exactly that place) while the page scrolls on.
     - Scrolling up, when the button's own place comes back down to that slot, it «docks» there again.
     - Nothing is shown on page load. If the button is already above the slot on load (short pages), it detaches
       when it slides under the sticky header and docks again at the slot.
     While detached, the button and its status tab are taken out of the page (no empty gap, Knut 2026-10-03); a
     zero-height marker keeps their place. The swap happens at the bottom edge, so the content in view does not move.
     Measured on scroll (no IntersectionObserver: the header covers the top and the info sheet is animated).
     The slot is read from the bar's real position, so Android's sliding address bar does not cause a jump. */
  var detached = false, prevTop = null;
  var marker = document.createElement('span');
  marker.setAttribute('data-buy-anchor', '');
  marker.style.display = 'block';
  main.parentNode.insertBefore(marker, main);
  function slotTop() {
    var control = bar.querySelector('[data-buy-control]');
    var r = bar.getBoundingClientRect();
    var bottom = r.bottom - (detached ? 0 : bar.offsetHeight);   // undo translateY(100%) while hidden
    return bottom - bar.offsetHeight + (control ? control.offsetTop : 0);
  }
  function setDetached(on, instant) {
    detached = on;
    if (instant) {
      bar.style.transition = 'none';
      requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.transition = ''; }); });
    }
    bar.classList.toggle('translate-y-full', !on);
    bar.setAttribute('aria-hidden', String(!on));
    bar.toggleAttribute('inert', !on);
    main.style.display = on ? 'none' : '';
    if (help) help.style.display = on ? 'none' : '';
    collapseEmptyGaps();   // the buy block is now empty (or full again): fix the gaps at once, so nothing jumps
  }
  /* Empty blocks and the row gap (Knut 2026-10-09): Shopify wraps every block in a div, and <product-form> is a flex column with a
     row gap, so a block that renders nothing (no variants, no engraving, no staff info, the buy button while the bar has taken
     it over ...) still adds a whole gap. Several of them left a big blank space. Every direct child with no height is pulled up
     by one gap, so exactly one gap remains where something is shown. Watched with a ResizeObserver, since blocks fill and empty
     themselves later (variant change, reviews, back in stock). */
  var gapColumn = form.closest('product-form');
  function collapseEmptyGaps() {
    if (!gapColumn) return;
    var gap = parseFloat(getComputedStyle(gapColumn).rowGap) || 0;
    Array.prototype.forEach.call(gapColumn.children, function (item) {
      var empty = gap > 0 && item.getBoundingClientRect().height < 1;
      if (empty) { item.style.marginTop = -gap + 'px'; item.setAttribute('data-gap-collapsed', ''); }
      else if (item.hasAttribute('data-gap-collapsed')) { item.style.marginTop = ''; item.removeAttribute('data-gap-collapsed'); }
    });
  }
  if (gapColumn) {
    var gapQueued = false;
    var queueGaps = function () {
      if (gapQueued) return;
      gapQueued = true;
      requestAnimationFrame(function () { gapQueued = false; collapseEmptyGaps(); });
    };
    if ('ResizeObserver' in window) {
      var gapObserver = new ResizeObserver(queueGaps);
      Array.prototype.forEach.call(gapColumn.children, function (item) { gapObserver.observe(item); });
    }
    window.addEventListener('resize', queueGaps);
    window.addEventListener('load', queueGaps);
    collapseEmptyGaps();
  }
  function updateSticky() {
    if (!bar) return;
    if (getComputedStyle(bar).display === 'none') { if (detached) setDetached(false, true); prevTop = null; return; }
    var top = marker.getBoundingClientRect().top;
    var slot = slotTop();
    var header = document.querySelector('.site-header');
    var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    if (!detached) {
      var arrived = prevTop !== null && prevTop > slot && top <= slot;      // reached the slot while scrolling down
      var underHeader = top + main.offsetHeight < headerBottom;              // short pages: passed under the header
      if (arrived || underHeader) setDetached(true, arrived);
    } else if (top > slot) {
      setDetached(false, true);                                              // its own place is back at the slot
    }
    prevTop = top;
  }
  if (bar) {
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', function () { prevTop = null; updateSticky(); });
    window.addEventListener('load', updateSticky);
    updateSticky();
  }
  /* PC (Knut 2026-10-04): the buy control with its status tab is a CSS-sticky block under the header (the mobile bar
     above is hidden on desktop). Once it has reached the header it gets is-stuck: white background, soft shadow and a
     centred «Til toppen» tab hanging under it (absolutely positioned, so the page does not shift). The header height
     is read into --pp-head-h. Scrolling back up it returns to its place by itself. */
  var pcQuery = window.matchMedia('(min-width: 768px)');
  var stickItem = null;
  (function () {
    var column = form.closest('product-form');
    var item = form;
    while (column && item.parentElement && item.parentElement !== column) item = item.parentElement;
    if (column && item !== column) { stickItem = item; item.classList.add('pp-buy-stick'); }
  })();
  function updateStuck() {
    if (!stickItem) return;
    var header = document.querySelector('.site-header');
    var headerH = header ? header.getBoundingClientRect().height : 0;
    if (headerH) stickItem.style.setProperty('--pp-head-h', headerH + 'px');
    var on = pcQuery.matches && window.scrollY > 0 && stickItem.getBoundingClientRect().top <= headerH + 1;
    stickItem.classList.toggle('is-stuck', on);
  }
  window.addEventListener('scroll', updateStuck, { passive: true });
  window.addEventListener('resize', updateStuck);
  window.addEventListener('load', updateStuck);
  updateStuck();

  window.PippeiBuy = { updateSticky: updateSticky };

  render();
})();
